import {Component, ElementRef, Input, ViewEncapsulation} from '@angular/core';
import {
  WhiteLabelSettingsFormKeys,
  WhiteLabelSettingsModel,
  WhiteLabelSettingsTab
} from "@atlas-workspace/shared/models";
import {whiteLabelPreviewStyleVariables} from "@atlas-workspace/shared/service";

@Component({
  selector: 'atl-shadow-dom-content',
  templateUrl: './shadow-dom-content.component.html',
  styleUrls: ['./shadow-dom-content.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
})
export class ShadowDomComponent {
  @Input() set whiteLabelSettings(value: WhiteLabelSettingsModel | null) {
    value && this.applyWLStyleProperties(value);
  }

  constructor(private readonly hostElement: ElementRef<HTMLElement>) {}

  private applyWLStyleProperties(settings: WhiteLabelSettingsModel): void {
    const variablesObject = whiteLabelPreviewStyleVariables[WhiteLabelSettingsTab.Email] as Record<string, string>;
    const valueObject = {
      [variablesObject[WhiteLabelSettingsFormKeys.EmailLinkColor]]: settings.emailLinkColor,
      [variablesObject[WhiteLabelSettingsFormKeys.EmailPrimaryTextColor]]: settings.emailPrimaryTextColor,
    };
    Object.entries(valueObject).forEach(([variable, value]) => {
      value = Number.isInteger(value) ? `${value}px` : `#${value}`;
      this.hostElement.nativeElement.style.setProperty(variable, String(value));
    });
  }
}
